// extracted by mini-css-extract-plugin
export default {"item":"static-templates-list_item__nRMO5","icon":"static-templates-list_icon__7RG-w"};